import { ConditionOnFieldEvaluator, operationBuilder } from './ConditionOnFieldEvaluator';

const ComparisonPropertiesSupported = {
  TYPE: "type",
  FIELDS: "fields",
  OPERATION: "operation",
  VALUE: "value"
} as const;

const ComparisonType = {
  COMPARE_VALUE: "compare_value",
  COMPARE_VARIABLES: "compare_variables"
} as const;

export class ComparisonConditionEvaluator extends ConditionOnFieldEvaluator {
  constructor() {
    super('comparisons');
  }

  isMatchCondition(condition: any, data: any): boolean {
    if (this.canHandleCondition(condition)) {
      const comparisons = condition[this.fieldName];
      return comparisons.every((comparison) => {
        const operation = comparison[ComparisonPropertiesSupported.OPERATION];
        switch (comparison[ComparisonPropertiesSupported.TYPE]) {
          case ComparisonType.COMPARE_VALUE: {
            const field = comparison[ComparisonPropertiesSupported.FIELDS][0];
            return (
              operationBuilder[operation] &&
              operationBuilder[operation](
                data[field],
                comparison[ComparisonPropertiesSupported.VALUE]
              )
            );
          }
          case ComparisonType.COMPARE_VARIABLES: {
            const field0 = comparison[ComparisonPropertiesSupported.FIELDS][0];
            const field1 = comparison[ComparisonPropertiesSupported.FIELDS][1];
            return (
              operationBuilder[operation] && operationBuilder[operation](data[field0], data[field1])
            );
          }
          default:
            return false;
        }
      });
    }
    return false;
  }
}
